export default "__VITE_ASSET__BpFC8kSg__"